export const StockLevel = {
  inStock: "inStock",
  lowStock: "lowStock",
  outOfStock: "outOfStock",
} as const;
export type StockLevel = (typeof StockLevel)[keyof typeof StockLevel];
